<template>
  <div class="comment first-comment thought in-list d-flex flex-sm-column flex-md-row" :class="thoughtClasses">
    <author :user="thought.owner" :createdDate="thought.created" />
    <div class="flex-md-grow-1">
      <div class="content">
        <div class="controls float-end">
          <div class="d-inline" v-if="canEditThought(thought)">
            <button
              class="btn btn-sm btn-link"
              v-tooltip="'Bearbeiten'"
              @click="openEditThought()"
              v-tooltip.bottom="'Bearbeiten'"
            >
              <font-awesome-icon icon="pencil-alt" aria-hidden="true" />
              <span class="visually-hidden">Bearbeiten</span>
            </button>
          </div>
        </div>
        <p v-dompurify-html="plainTextContent"></p>
        <div class="attachment-list">
          <attachments v-if="thought.files.length > 0" :files="thought.files" />
        </div>
        <template v-if="thought.last_update !== thought.created">
          <p class="small mt-3 fst-italic">
            - Bearbeitet:
            {{ formattedDate(UTCtoLocalTime(thought.last_update)) }}
          </p>
        </template>
        <admin-link :links="thought.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

// stores
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';

// components
import Author from '@/components/forum/elements/Author.vue';
import Attachments from '@/components/general/Attachments.vue';
import AdminLink from '@/components/general/AdminLink.vue';

// composables
import useConverter from '@/composables/general/useConverter';
import useThoughtConfig from '@/composables/thought/useThoughtConfig';

export default {
  name: 'forum-thought-in-comment-list',
  props: {
    thought: {
      type: Object,
      required: true,
    },
  },
  emits: ['edit-thought'],

  setup(props, context) {
    const { formattedDate, UTCtoLocalTime } = useConverter();
    const { canEditThought } = useThoughtConfig();

    //
    //-----------------COMPUTED------------------
    //
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const plainTextContent = computed(() => {
      const doc = new DOMParser().parseFromString(props.thought.content, 'text/html');
      return doc.body.textContent || '';
    });
    const thoughtClasses = computed(() => {
      return {
        ['thought-' + props.thought.id]: true,
      };
    });

    //
    //-----------------METHODS------------------
    //

    function openEditThought(event) {
      if (canEditThought(props.thought)) {
        context.emit('edit-thought', {});
      }
    }

    return {
      // REFS

      // COMPUTED
      domainid,
      isLoggedIn,
      plainTextContent,
      thoughtClasses,

      // METHODS
      formattedDate,
      UTCtoLocalTime,
      canEditThought,
      openEditThought,
    };
  },

  components: {
    Author,
    Attachments,
    AdminLink,
  },
};
</script>

<style scoped lang="scss">
.thought.in-list {
  border-top: solid 1px #eee;
}
.thought .content {
  padding: 10px;
  white-space: pre-wrap;
}
</style>
